(() => {
  if (window.tcsCustomOptionsDelegated) return;
  window.tcsCustomOptionsDelegated = true;

  function updateProperty(input) {
    const scope = input.closest('product-info') || input.closest('.shopify-section');
    if (!scope) return;
    let hiddenInputId = input.dataset.hiddenInputId;
    if (input.matches('input[name^="custom_option_"], select[name^="custom_option_"]')) {
      if (input.type === 'radio' && !input.checked) return;
      hiddenInputId = `product-form-input-${input.dataset.optionName}-${input.dataset.blockId}`;
    }
    if (!hiddenInputId) return;
    const hiddenInput = scope.querySelector(`#${CSS.escape(hiddenInputId)}`);
    if (hiddenInput) {
      hiddenInput.value = input.type === 'checkbox' ? (input.checked ? 'Yes' : 'No') : input.value;
    }
  }

  const selector = '.custom-checkbox-input, .custom-text-field, input[name^="custom_option_"], select[name^="custom_option_"]';
  document.addEventListener('input', (event) => {
    if (event.target.matches(selector)) updateProperty(event.target);
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches(selector)) updateProperty(event.target);
  });
})();
